import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { EventsStateActions } from './events-state.actions';
import { EventsStateModel } from './events-state.model';
import { BandmanagerRestApiEventParticipation, BandmanagerRestApiEventStatusEnum } from '@digitale-menschen/bandmanager-rest-api';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
dayjs.extend(isSameOrAfter);


@State<EventsStateModel>({
  name: 'eventsState',
  defaults: {
    eventsParticipations: [],
  },
})
@Injectable()
export class EventsState {

  @Selector()
  static nextParticipations(state: EventsStateModel): BandmanagerRestApiEventParticipation[] {
    const eventParticipations = state.eventsParticipations;
    if (eventParticipations && eventParticipations.length) {
      return eventParticipations.filter(
        item => item.eventSection.event.eventStatus === BandmanagerRestApiEventStatusEnum.Scheduled && item.eventSection.event.startAt && dayjs(
          item.eventSection.event.startAt).isSameOrAfter(dayjs()));
    }
    return [];
  }

  @Selector()
  static inProgressParticipations(state: EventsStateModel): BandmanagerRestApiEventParticipation[] {
    const eventParticipations = state.eventsParticipations;
    if (eventParticipations && eventParticipations.length) {
      return eventParticipations.filter(
        item => (item.eventSection.event.eventStatus === BandmanagerRestApiEventStatusEnum.InProgress || item.eventSection.event.eventStatus === BandmanagerRestApiEventStatusEnum.DrawSet));
    }
    return [];
  }

  @Selector()
  static eventsParticipations(state: EventsStateModel): BandmanagerRestApiEventParticipation[] {
    return state.eventsParticipations;
  }

  @Action(EventsStateActions.setEventsParticipations)
  setEventsParticipations(ctx: StateContext<EventsStateModel>, payload: EventsStateActions.setEventsParticipations) {
    ctx.patchState({
      eventsParticipations: payload.participations,
    });
  }
}
